import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {FormattedMessage, useIntl} from "react-intl";
import DeliveryAreasHeadingActions from "@widgets/deliveryAreas/overview/heading/DeliveryAreasHeadingActions";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";
import {SetStateFn} from "@/utils/SetStateUtils";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

type Props = {
    route: Route,
    setEditModal: SetStateFn<EditDeliveryAreaState>,
};

const DeliveryAreasHeading = ({route, setEditModal}: Props) => {
    const intl = useIntl();
    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage({id: "deliveryAreas"})}
                actionRowHorizontal={false}
                actionRow={<DeliveryAreasHeadingActions setEditModal={setEditModal}/>}
                breakpoints={{md: {actionRowHorizontal: true}}}
                meta={<LocationPageMeta/>}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"deliveryAreasExplanation"}/>
            </p>
        </div>
    );
};

export default DeliveryAreasHeading;